module.exports = __webpack_public_path__ + "img/w-occupancy-rate.478e5380.svg";